export enum SpecialCampaignEnum {
  HenriqueEJuliano = "henrique-juliano",
}
